import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import "../../styles.css";

export default function ManageHomeHero() {
  const [hero, setHero] = useState({
    backgroundUrl: "/assets/sekolah.png",
    title: "Selamat Datang di Website Resmi",
    schoolName: "SMP Muhammadiyah 2 Bolang Dayeuhluhur",
    description: "Tempat tumbuhnya generasi cerdas, berakhlak, dan berprestasi."
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const docRef = doc(db, "homePage", "hero");
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) setHero(docSnap.data());
    });
    return () => unsubscribe();
  }, []);

  const handleChange = (e) => setHero({ ...hero, [e.target.name]: e.target.value });

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const docRef = doc(db, "homePage", "hero");
      await setDoc(docRef, hero, { merge: true }); // membuat dokumen jika belum ada
      Swal.fire("Berhasil", "berhasil diperbarui!", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Gagal memperbarui ", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h3>Kelola Hero Halaman Depan</h3>

      {/* Preview Hero */}
      <div className="hero-container position-relative my-4">
        <img
          src={hero.backgroundUrl}
          alt="Hero"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
        <div className="hero-text position-absolute top-50 start-50 translate-middle text-center text-white px-3"
             style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}>
          <h1 className="display-4 fw-bold">{hero.title}</h1>
          <h2 className="h3 fw-normal mt-3">{hero.schoolName}</h2>
          <p className="mt-3">{hero.description}</p>
        </div>
      </div>

      {/* Form Input */}
      <label className="mt-3">URL Background</label>
      <input
        className="form-control"
        name="backgroundUrl"
        value={hero.backgroundUrl}
        onChange={handleChange}
      />

      <label className="mt-3">Judul</label>
      <input
        className="form-control"
        name="title"
        value={hero.title}
        onChange={handleChange}
      />

      <label className="mt-3">Nama Sekolah</label>
      <input
        className="form-control"
        name="schoolName"
        value={hero.schoolName}
        onChange={handleChange}
      />

      <label className="mt-3">Deskripsi</label>
      <textarea
        className="form-control"
        name="description"
        value={hero.description}
        onChange={handleChange}
      />

      <button
        className="btn btn-primary mt-4"
        onClick={handleUpdate}
        disabled={loading}
      >
        {loading ? "Menyimpan..." : "Simpan Perubahan"}
      </button>
    </div>
  );
}
